import { useTranslation } from 'gatsby-plugin-react-i18next';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

import SearchInput from './SearchInput';
import { SELLING_SEARCH_ROUTE } from '../../utils/routes/const';

const imageQuery = graphql`
query {
  image: file(base: {eq: "sellingHero.png"}) {
    name
    childImageSharp {
      gatsbyImageData(
        width: 445,
      )
    }
  }
  security: file(base: {eq: "security.svg"}) {
    publicURL
  }
  paymentGuaranteed: file(base: {eq: "payment-guaranteed.svg"}) {
    publicURL
  }
}`;


const SellingHero = ({
  title = 'sellingHero.title',
  displayForm = true,
  bgColor = 'bg-blue',
  fullHeight = true,
}: {
  title?: string;
  displayForm?: boolean;
  bgColor?: string;
  fullHeight?: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <section className={`pt-20 lg:pt-12 pb-12 px-8 ${bgColor}`}>
      <div className="w-full max-w-screen-2xl mx-auto flex items-center">
        <div className="lg:w-1/12 lg:block hidden" />
        <div className={`${fullHeight ? 'lg:h-screen' : ''} flex flex-col justify-center`}>
          <div className="flex justify-between">
            <div className="lg:w-5/12">
              <h1 className="font-cirka text-4xl lg:text-6xl text-left text-primary mb-8" >{t(title)}</h1>
              <p className="text-gray-400 text-lg">{t('sellingHero.subtitle')}</p>
            </div>
            <div className="hidden lg:flex" >
              <SellingHeroImages />
            </div>
          </div>
          {displayForm && (
            <form action={SELLING_SEARCH_ROUTE} className="mt-12 lg:mt-24 w-11/12" autoComplete='off' data-test="selling-search-form">
              <p className="mb-4 text-gray-400" dangerouslySetInnerHTML={{ __html: t('sellingHero.searchText') }} />
              <SearchInput displayResults={false} />
            </form>
          )}
          <div className="flex lg:hidden pt-12 lg:pt-0">
            <SellingHeroImages />
          </div>
        </div>
      </div>
    </section>
  );
}

const SellingHeroImages = () => {
  const { image, security, paymentGuaranteed } = useStaticQuery(imageQuery);

  return (
    <>
      <GatsbyImage image={image.childImageSharp.gatsbyImageData} alt="watch" className="w-8/12 lg:w-auto" />
      <div className="ml-6 lg:ml-8">
        <img alt="payment guaranteed" src={paymentGuaranteed.publicURL} className="w-24 h-24 mb-6" loading="lazy" />
        <img alt="security" src={security.publicURL} className="w-24 h-24 mb-6" loading="lazy" />
      </div>
    </>
  )
}

export default SellingHero;

